import Button from '@/common/components/Button'
import { ShowHeader } from '@/common/components/ShowHeader'
import { useGoBack } from '@/common/hooks/useGoBack'
import { useMaintenanceWorkflow } from '@/features/maintenanceWorkflow/pages/Create/hooks/useMaintenanceWorkflow'
import { ChevronsRightIcon } from 'lucide-react'
import { useParams } from 'react-router-dom'

interface CreateMaintenanceForwardingHeaderProps {
  actions?: JSX.Element
  showCancelButton?: boolean
}

const CreateMaintenanceForwardingHeader = ({ actions, showCancelButton }: CreateMaintenanceForwardingHeaderProps) => {
  const { id: workflowId, directiveEntryType } = useParams()

  const goBack = useGoBack()

  const { data: workflow, isPending: workflowIsPending } = useMaintenanceWorkflow(workflowId)

  return (
    <ShowHeader
      goBack
      goBackProps={{
        fallback: directiveEntryType
          ? `/maintenance-workflows/${workflowId}/forwardings/create`
          : `/maintenance-workflows/${workflowId}`,
        searchLastRouteFromFallback: true,
      }}
      isLoading={workflowIsPending}
      title="Processos de manutenção (OS)"
      subtitle={
        <div className="flex items-center gap-2">
          <p>{workflow?.id.split('-')[0].toUpperCase() || ''}</p>

          <ChevronsRightIcon />

          <p className="text-white-800">Encaminhar</p>
        </div>
      }
      titleClassName="text-md"
      className="text-white-400"
      subtitleClassName="text-nowrap font-medium"
      buttons={
        <div className="flex items-center gap-3">
          {showCancelButton && (
            <Button
              variant="outline-error"
              onClick={() =>
                goBack({
                  fallback: directiveEntryType
                    ? `/maintenance-workflows/${workflowId}/forwardings/create`
                    : `/maintenance-workflows/${workflowId}`,
                  searchLastRouteFromFallback: true,
                })
              }
            >
              Cancelar
            </Button>
          )}

          {actions}
        </div>
      }
    />
  )
}

export default CreateMaintenanceForwardingHeader
